import {Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {FullViewDialogService} from "../fullView/fullViewDialog.service";
import {ResultUtil} from '../../nddUtils/resultUtil.service';
import {BriefResultService} from '../briefResult/briefResult.service';
import {SearchService} from '../search.service';
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';
import {ChangeLangService} from "../../infra/lang/changeLang.service";

@Component({
    selector: 'prm-reference-entry-item',
    templateUrl: 'components/search/referenceEntry/reference-entry-item.html',
})

export class PrmReferenceEntryItem{

    @Input() public term;
    public description;
    public title;
    public descCropped;
    public showViewMoreButton;
    public item: any;
    constructor(private briefResultService: BriefResultService,
                private searchService: SearchService,
                private fullViewDialogService: FullViewDialogService,
                @Inject('$state') private $state: angular.ui.IStateService,
                @Inject('$scope') private $scope: ng.IScopeService,
                private configurationUtil : ConfigurationUtil,
                private resultUtil: ResultUtil,
                private changeLangService: ChangeLangService) {
    }

    ngOnInit() {
        let deregister = this.$scope.$watch(()=>this.showViewMoreBtn(), (val)=>{this.showViewMoreButton = val; if(val) deregister();})
	    this.searchService.getReferenceEntry(this.term)
        .then((response) => {
                if (!this.configurationUtil.isSuprima()) {this.onSuccess(response), (response) => this.onError(response)} else {
                		if (response[0].length!==0 && ((response[0].docs!=undefined && response[0].docs.length!==0) || (response[0].pnx !=undefined && response[0].pnx.length!==0))){
                			this.item=response[0];
                			this.description = this.item.pnx.display.description;
                			this.descCropped = true;
                		}
                	}
            });
    }

    private onSuccess(response) {
		if(response) {
			this.item = response.data.docs[0];
			this.description = this.item.pnx.display.description;
			this.descCropped = true;
		}
	}

	private onError(response){
		console.log("An error occurred while getting ReferenceEntry");
	}


     public toggleDescCropped(){
        this.descCropped = !this.descCropped;
    }

    public showViewMoreBtn(){
        let descParagraphElem = document.getElementById('reference-entry-description');
        if (descParagraphElem) {
        	let descParagraphHeight = descParagraphElem.clientHeight;
        	let descDivHeight = descParagraphElem.parentElement.clientHeight;
//        	console.log("descParagraphHeight: " + descParagraphHeight + " descDivHeight: " + descDivHeight);
        	if (descParagraphHeight > descDivHeight || !this.descCropped){
            	return true;
        	} else {
            	return false;
        	}
    	}
        return false;
    }

    private switchToLtrString() {
        return this.changeLangService.direction == 'rtl';
    }

    public getViewMoreButtonText(){
        if (this.descCropped){
            return "reference_entry.button.view_more";
        } else {
            return "reference_entry.button.view_less";
        }
    }


    public openFullViewDialog(event){
        this.fullViewDialogService.openFullViewDialog(this.item, event, 'referenceEntry');
    }

    public isMultipleVersions() {
        return this.resultUtil.displayMultipleVersions(this.item, this.briefResultService.getSearchObject());
    }

    public isFavoriteState() {
        if (this.$state.current.name == STATE_NAMES.FAVORITES) {
            return true;
        }
        return false;
    }

    public isFrbrGeneric() {
        return this.resultUtil.isFrbr(this.item) && this.searchService.getFrbrDisplay() === 1;  //Generic Record
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/referenceEntry/referenceEntryItem.directive.ts